import { render, staticRenderFns } from "./CompareTool.vue?vue&type=template&id=731563e2&scoped=true&"
import script from "./CompareTool.vue?vue&type=script&lang=js&"
export * from "./CompareTool.vue?vue&type=script&lang=js&"
import style0 from "./CompareTool.vue?vue&type=style&index=0&id=731563e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731563e2",
  null
  
)

export default component.exports